module.exports = __webpack_public_path__ + "static/media/person2.ab99e5fe.png";